import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { checkRole } from '../../helpers/Roles';
import IconSetTemplate from '../../assets/images/setting/icon-set-template.png';
import IconSetClinic from '../../assets/images/setting/icon-set-clinic.png';
import IconSetWorktime from '../../assets/images/setting/icon-set-worktime.png';
import IconSetRole from '../../assets/images/setting/icon-set-role.png';
import IconSetReceipts from '../../assets/images/setting/icon-set-receipts.png';
import IconSetService from '../../assets/images/setting/icon-set-service.png';
import IconSetUser from '../../assets/images/setting/icon-set-user.png';
import IconSetBranch from '../../assets/images/setting/icon-set-branch.png';
import { baseUrl } from '../../constants/environment';
import APIClient from '../../helpers/APIClient';
import { toast } from 'react-toastify';

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const PriceConfig: React.FC<Props> = (props: any) => {
    const {user} = props
    const router = useHistory()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        price_cost_config: ''
    })

    useEffect(() => {
        document.title = 'Cấu hình phương pháp tính giá vốn'
        loadData()
    }, []);

    const loadData = async () => {
        const url = `${baseUrl}/auth/me`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setData({
                price_cost_config: resData?.store_id?.price_cost_config,
            })
        }
    }

    const handleSubmit = async () => {
        setLoading(true)
        const url = `${baseUrl}/store/price-cost-config`;
        const params = {
            price_cost_config: data?.price_cost_config
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Cập nhật cấu hình phương thức tính giá vốn thành công')
            loadData()
        }
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: `Cấu hình phương pháp tính giá vốn`, active: true },
                    ]}
                    title={`Cấu hình phương pháp tính giá vốn`}
                />
                <ContentPage 
                    {...props} data={data} setData={setData}loading={loading} setLoading={setLoading}
                />
                <div className="bottom-action">
                    <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                    <Button color="success" className='ml-2' onClick={handleSubmit}>Xác nhận</Button>
                </div>
                {loading && <Loader/>}
            </React.Fragment>
        </div>
    );
};

const ContentPage = (props:any) => {
    const {user, data, setData, loading, setLoading} = props
    
    return (
        <PageContent>
            <PageBody>
                <div className="nutri-title mb-3">Cấu hình phương pháp tính giá vốn</div>
                <Row>
                    <Col md={6} xs={12}>
                        <FormGroup className='nutri-form'>
                            <div className="d-flex align-items-center">
                                <div className={data?.price_cost_config == 'weighted_average_after_import' ? "nutri-radio active" : "nutri-radio"} onClick={() => setData({...data, price_cost_config:'weighted_average_after_import'}) }>
                                    <div className="icon"></div>
                                    <div className="label">Bình quân gia quyền sau mỗi lần nhập (Tức thời)</div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mb-2 mt-2">
                                <span>Công thức tính giá vốn</span>
                            </div>
                            <div className="price_config" style={{display: 'flex', alignItems: 'center', justifyContent: 'cente'}}>
                                <div className="col-lg-2">
                                    <span>Đơn giá xuất kho lần thứ i</span>
                                </div>
                                <div className="col-lg-1">
                                    <span>=</span>
                                </div>
                                <div className="col-lg-9" style={{display: 'flex', flexDirection: 'column'}}>
                                    <span>Trị giá hàng hóa tồn đầu kỳ + Trị giá hàng hóa nhập trước lần xuất thứ i</span>
                                    <span className="line-border" style={{margin: '10px 0'}} />
                                    <span>Số lượng hàng hóa tồn đầu kỳ + Số lượng hàng hóa nhập trước lần xuất thứ i</span>
                                </div>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </PageBody>
            {loading && <Loader />}
        </PageContent>
    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default connect(mapState)(PriceConfig)